import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'wouter';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';
import { privacyPolicyHtml } from './privacy-content';

export default function PrivacyPage() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Remodra</title>
        <meta name="description" content="Privacy Policy for Remodra" />
        <link rel="canonical" href="https://getremodra.com/privacy" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "Home", item: "https://getremodra.com/" },
              { "@type": "ListItem", position: 2, name: "Privacy Policy" }
            ]
          })}
        </script>
      </Helmet>
      <div className="min-h-screen bg-white">
        <div className="max-w-4xl mx-auto px-4 py-12">
          {/* Navigation buttons */}
          <div className="mb-6 flex gap-3">
            <Button variant="outline" asChild>
              <Link href="/">
                <Home className="h-4 w-4 mr-2" />
                Back to Home
              </Link>
            </Button>
            <Button variant="outline" onClick={() => window.history.back()}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
          </div>
          
          {/* Privacy Policy content */}
          <div dangerouslySetInnerHTML={{ __html: privacyPolicyHtml }} />
        </div>
      </div>
    </>
  );
}

